import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { t } from '../../../../../types/translation/Translator';
import { TagContext } from '../../../../../context/TagContext';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { FilterProps } from '../../common/filter.util';
import { TagFilter } from '../TagFilter';
import { EntityType } from '../../../../../types/comment';

interface TagFilterDropdownContentProps {
  entityType: EntityType;
  filter: TagFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function TagFilterDropdownContent({
  entityType,
  filter,
  filterProps,
  setFilterProps,
}: TagFilterDropdownContentProps) {
  const { tags } = useContext(TagContext);

  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    const items = new Set<string>();
    for (const tag of tags.values()) {
      if (tag.type !== entityType) continue;
      if (!filter.search(tag, query)) continue;
      if (filterProps.company?.size && !filterProps.company.has(tag.companyId)) continue;
      items.add(tag.id);
    }
    return items;
  }, [query, tags, filter, entityType]);

  const handleChange = (selected: Set<string>) => {
    if (!filterProps.tags) filterProps.tags = new Map();

    filterProps.tags.set(entityType, selected);

    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.tags?.set(entityType, new Set());
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.tag).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.tags?.get(entityType)}
          values={values}
          onChange={handleChange}
          toText={id => tags.get(id)?.name}
        />
      </Grid>
    </Grid>
  );
}
